module.exports = __webpack_public_path__ + "2e05d0a58d1d92f3bc95a1fb996d07f8.svg";